import "./About.css";
import aboutImage from "../../../images/ellipseElectricity.png";

function About() {

  return (
    <section className="about">
      <div className="about__container">
        <h1 className="about__title">Энергосбытовая компания</h1>
        <p className="about__text">
          Поставка электроэнергии потребителям<br/>на всей территории Российской Федерации<br/>с 2010 года
        </p>
      </div>
      <img className="about__image" src={aboutImage} alt="Изображение трансформаторной подстанции"></img>
    </section>
  )
}

export default About;